import { useState } from 'react';
import { css, cx } from 'linaria';
import { CloseButton } from 'components/close-button/close-button';
import { SectionWrapper } from 'components/section-wrapper/section-wrapper';
import { Fade } from 'common/utilities/animation/fade';
const snackbar = "soy7dq2";
const wrapper = "w1sa61ai";
const closeButtonOverrides = "c61kr8s";
export function Snackbar({
  showMessage,
  title,
  type
}) {
  const [isVisible, setVisible] = useState(showMessage);

  const remove = () => {
    setVisible(false);
  };

  return <Fade show={isVisible} remove={remove}>
      <SectionWrapper className={cx(wrapper, type)}>
        <div className={snackbar}>
          <div className="snackbar_title">
            <p>{title}</p>
            <CloseButton handleClose={remove} closeButtonOverrides={closeButtonOverrides} />
          </div>
        </div>
      </SectionWrapper>
    </Fade>;
}

require("./snackbar.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./snackbar.js");